import { SessionState, UpdateSession, ActionType } from 'types';

export const updateSession = (session: Partial<SessionState>): UpdateSession => ({
  payload: session,
  type: ActionType.UpdateSession,
});
